module.exports = __webpack_public_path__ + "img/x-Pt.3a463b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Pt.jpg
// module id = dC/g
// module chunks = 1